import React from 'react'
import { StyledLoader } from './GlobalStyles'
import { LoadingOutlined } from '@ant-design/icons'

export default () => (
  <StyledLoader>
    <LoadingOutlined />
  </StyledLoader>
)
